import React, { FC, ReactNode, useMemo } from "react";
import "./TitleRowWithContent.scss";

type Props = {
  title: string;
  content: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  defaultOpen?: boolean;
};

const TitleRowWithContent: FC<Props> = ({
  title,
  children,
  content,
  description,
}) => {
  const headerClassName = useMemo(() => {
    if (!description) {
      return "header";
    }

    return "header header--with-description";
  }, [description]);

  return (
    <div className="container">
      <div className={headerClassName}>
        <div className="header__heading">
          <h4>{title}</h4>
          {description ? (
            <p className="header__description">{description}</p>
          ) : null}
        </div>
        <div className="header__content">{content}</div>
      </div>
      {children}
    </div>
  );
};

export default TitleRowWithContent;
